var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecklist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39.321,
    height: 39.321,
    fill: "none",
    viewBox: "0 0 39.321 39.321",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m19.66 38.821c10.582 0 19.16-8.5784 19.16-19.16 0-10.582-8.5783-19.16-19.16-19.16-10.582 0-19.16 8.5784-19.16 19.16 0 10.582 8.5784 19.16 19.16 19.16z",
    fill: "url(#paint0_linear_35_1927)",
    style: {
      fill: "url(#paint0_linear_35_1927)",
      stroke: "#5586e2"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_35_1927",
    x1: 7.0452,
    x2: 32.088,
    y1: 8.8636,
    y2: 31.354,
    gradientTransform: "translate(.5 .5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E7BFD",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34A5ED",
    offset: 0.46404
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDC44",
    offset: 1
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m9.1122 19.001 7.4715 7.4716 13.625-13.625",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4,
      stroke: "#ffffff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/checklist.a316221447f665ca3f661153fcd75eba.svg";
export { ForwardRef as ReactComponent };